export const COL_LOOP = 'w-20 shrink-0';
export const COL_ITEM = 'w-28 shrink-0';
export const COL_DIRECTION = 'w-20 shrink-0';
export const COL_TYPE = 'w-44 shrink-0';
export const COL_MESSAGE = 'min-w-0 flex-1';
export const COL_AFFECTED = 'w-52 shrink-0';
export const COL_ACTIONS = 'w-40 shrink-0';
